module.exports = __webpack_public_path__ + "img/duke-logo-white.210c546e.png";